import { render, staticRenderFns } from "./logo-site.vue?vue&type=template&id=1807992a&scoped=true&"
var script = {}
import style0 from "./logo-site.vue?vue&type=style&index=0&id=1807992a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807992a",
  null
  
)

export default component.exports